export const messages = {
    NO_INFORMATION: 'Não informado',
    NO_GLASS: 'SEM VIDRO',
};